// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__2HU15","actions":"GroupTable_actions__2HD4k","deleteModalFooter":"GroupTable_deleteModalFooter__bY6JZ"};